import React from 'react';
import { isResizeObserverSupported } from '../../../common/utils/is-resize-observable-supported';
export const useListFitsToScreen = (resourceId, displayedCommentCount) => {
    const [listFitsToScreen, setListFitsToScreen] = React.useState(true);
    // We need to update when element is added/changed so we use state instated of ref
    const [element, setElement] = React.useState(null);
    // Reset to default on new resource
    React.useEffect(() => {
        setListFitsToScreen(true);
    }, [resourceId]);
    // If browser has ResizeObserver support we use it
    React.useEffect(() => {
        if (!element || !isResizeObserverSupported()) {
            return;
        }
        const resizeObserver = new window.ResizeObserver(() => {
            const fitsToScreen = element.clientHeight <= document.documentElement.clientHeight;
            if (!fitsToScreen && listFitsToScreen) {
                // After showing the bottom box we don't want to suddenly hide it even if list again
                // fits to screen - there might be some user content in the box
                setListFitsToScreen(false);
            }
        });
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [element]);
    // If browser does not support ResizeObserver we fallback to item count
    React.useEffect(() => {
        if (isResizeObserverSupported()) {
            return;
        }
        if (displayedCommentCount > 5 && listFitsToScreen) {
            setListFitsToScreen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayedCommentCount]);
    return {
        listRef: setElement,
        listFitsToScreen,
    };
};
//# sourceMappingURL=use-list-fits-to-screen.js.map